import { render, staticRenderFns } from "./variation-icon.vue?vue&type=template&id=173d80a4&"
import script from "./variation-icon.vue?vue&type=script&lang=js&"
export * from "./variation-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports